import Cookies from "js-cookie";

const BASE_URL = "https://apiwebadmin.getqcall.com/api/v1";

const getLocale = async () => {
  try {
    if (typeof window !== "undefined") {
      return Cookies.get("NEXT_LOCALE") || "en";
    } else {
      // For server-side rendering, use default locale
      // This avoids the dynamic server usage error
      return "en";
    }
  } catch (error) {
    console.error("Error getting locale:", error);
    return "en";
  }
};

const http = async (url, options = {}) => {
  try {
    const locale = await getLocale();
    const res = await fetch(`${BASE_URL}/${url}`, {
      next: {
        revalidate: 100,
      },
      method: options.method || "GET",
      ...options,
      headers: {
        "Content-Type": "application/json",
        lang: locale,
        ...(options?.headers || {}),
      },
    });

    if (!res.ok) {
      // For build time, return null instead of throwing error
      if (
        process.env.NODE_ENV === "production" ||
        process.env.NEXT_PHASE === "phase-production-build"
      ) {
        console.warn(
          `API request failed for ${url}: ${res.status} ${res.statusText}`
        );
        return null;
      }
      const errorMessage = `Error ${res.status}: ${res.statusText}`;
      throw new Error(errorMessage);
    }

    return res.json();
  } catch (error) {
    console.error("HTTP request failed:", error);
    // For build time, return null instead of throwing error
    if (
      process.env.NODE_ENV === "production" ||
      process.env.NEXT_PHASE === "phase-production-build"
    ) {
      return null;
    }
    throw error;
  }
};

export default http;
